import { UPDATE_CHANNEL_INFO, UPDATE_STATUS, UPDATE_LOADING, UPDATE_EXPANDED_GROUP, UPDATE_IS_EDITING, UPDATE_PINS_EXPANDED_GROUP } from './actionType';

const defaultState = {
  channelId: null,
  contentLoading: false,
  setupTableUpdate: false,
  isEditing: false,
};

export const D2DReducer = (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_CHANNEL_INFO:
      return {
        ...state,
        ...action.obj
      }
    case UPDATE_LOADING:
      return {
        ...state,
        [action.key]: action.loading
      }
    case UPDATE_STATUS:
      return {
        ...state,
        [action.key]: action.status
      }
    case UPDATE_EXPANDED_GROUP:
      return {
        ...state,
        expandedGroupKeys: action.expandedGroupKeys
      }
    case UPDATE_IS_EDITING:
      return {
        ...state,
        isEditing: action.isEditing
      }
    case UPDATE_PINS_EXPANDED_GROUP:
      return {
        ...state,
        pinsExpandedGroupKeys: action.pinsExpandedGroupKeys
      }
    default: return state;
  }
}